'use client'
import { useState } from 'react';
import { useRouter, useSearchParams } from 'next/navigation';
import Link from 'next/link';
import { signIn } from 'next-auth/react';

export default function LoginForm() {
    const router = useRouter();
    const searchParams = useSearchParams();
    const [mobile, setMobile] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const callbackUrl = searchParams?.get('callbackUrl') || '/profiles';
            const res = await signIn('credentials', {
                redirect: false,
                mobile,
                password,
                callbackUrl
            });

            if (res?.error) {
                setError('Invalid mobile number or password');
            } else if (res?.ok) {
                // Successful login - determine destination based on role
                try {
                    const sessRes = await fetch('/api/auth/session');
                    const sessData = await sessRes.json();
                    const userRole = sessData?.user?.role;

                    if (userRole === 'master_admin' || sessData?.user?.isAdmin === true) {
                        router.push('/admin/dashboard');
                    } else {
                        router.push(callbackUrl);
                    }
                    router.refresh();
                } catch (err) {
                    // fallback
                    router.push(callbackUrl);
                    router.refresh();
                }
            }
        } catch (err) {
            console.error('Login error:', err);
            setError('An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="registra_fo_container">
            <div className="registra_fo_header">
                <h1 className="registra_fo_title">Login / લૉગિન</h1>
                <p className="registra_fo_subtitle">SSC Batch 2001 - Silver Jubilee</p>
            </div>

            <div className="registra_fo_main">
                <form className="registra_fo_form" onSubmit={handleSubmit} style={{ maxWidth: '500px', margin: '0 auto' }}>
                    <h2 className="registra_fo_form_title">Login to Your Account</h2>

                    {error && (
                        <div style={{
                            padding: '1rem',
                            marginBottom: '1rem',
                            backgroundColor: '#f8d7da',
                            color: '#721c24',
                            borderRadius: '5px',
                            textAlign: 'center'
                        }}>
                            {error}
                        </div>
                    )}

                    <div className="registra_fo_form_group">
                        <label className="registra_fo_label" htmlFor="mobile">
                            Mobile Number / મોબાઇલ નંબર*
                        </label>
                        <input
                            type="tel"
                            id="mobile"
                            className="registra_fo_input"
                            required
                            placeholder="Enter your mobile number"
                            value={mobile}
                            onChange={(e) => setMobile(e.target.value)}
                        />
                    </div>

                    <div className="registra_fo_form_group">
                        <label className="registra_fo_label" htmlFor="password">
                            Password / પાસવર્ડ*
                        </label>
                        <input
                            type="password"
                            id="password"
                            className="registra_fo_input"
                            required
                            placeholder="Enter password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>

                    <div className="registra_fo_form_group">
                        <button type="submit" className="registra_fo_submit_btn" disabled={loading}>
                            {loading ? 'Logging in...' : 'Login / લૉગિન કરો'}
                        </button>
                    </div>

                    <div style={{ textAlign: 'center', marginTop: '1rem' }}>
                        <p>Don't have an account? <Link href="/registration" style={{ color: '#4CAF50', textDecoration: 'underline' }}>Register here</Link></p>
                    </div>
                </form>
            </div>

            <div className="registra_fo_footer">
                <p>&copy; આયોજન સમિતિ (SSC બેચ ૨૦૦૧)</p>
            </div>
        </div>
    );
}
